<template>
  <div ref="root" class="call2 topPage">
    <div class="slider-outer">
      <div class="slider-inner">
        <template :key="idx" v-for="(slide, idx) in state.slides">
          <img :class="state.current_slide == idx ? 'active' : ''" class="slide-img" v-bind:src="state.slides[0].img" />
        </template>
      </div>
      <div class="over-ray">
        <div class="top-inner">
          <div class="top-items-title">
            <h2>Contact</h2>
            <p>問い合わせ</p>
          </div>
        </div>
      </div>
    </div>

    <div id="app" class="contact">
      <form class="contact-form" method="post" action="">
        <table>
          <tbody>
            <tr>
              <th>お名前<br /><span class="tag">必須</span></th>
              <td>
                <input v-model="state.name" placeholder="例）宮元 啓介" />
                <p class="error">{{ errors.name }}</p>
              </td>
            </tr>
            <tr>
              <th>フリガナ<br /><span class="tag">必須</span></th>
              <td>
                <input v-model="state.kana" placeholder="例）ミヤモト ケイスケ" />
                <p class="error">{{ errors.kana }}</p>
              </td>
            </tr>
            <tr>
              <th>電話番号<br /><span class="tag">必須</span></th>
              <td>
                <input v-model="state.tel" placeholder="例）03-5672-9860" />
                <p class="error">{{ errors.tel }}</p>
              </td>
            </tr>
            <tr>
              <th>メールアドレス<br /><span class="tag">必須</span></th>
              <td>
                <input v-model="state.email" placeholder="例）k.m.cyclone1216@gmail.com" />
                <p class="error">{{ errors.email }}</p>
              </td>
            </tr>
            <tr>
              <th>お問い合わせ項目<br /><span class="tag">必須</span></th>
              <td>
                <select name="time" v-model="state.contentstype">
                  <option value="">選択してください</option>
                  <option value="体験-フリータイム枠">体験-フリータイム枠</option>
                  <option value="体験-キック初級クラス">体験-キック初級クラス</option>
                  <option value="体験-エントリーキッククラス">体験-エントリーキッククラス</option>
                  <option value="体験-レディースエントリークラス">体験-レディースエントリークラス</option>
                  <option value="体験-レディースキッククラス">体験-レディースキッククラス</option>
                  <option value="体験-学生クラス">体験-学生クラス</option>
                  <!-- <option value="体験-ヨガクラス">体験-ヨガクラス</option>
                  <option value="体験-ピラティスクラス">体験-ピラティスクラス</option> -->
                  <option value="見学希望">見学希望</option>
                  <option value="その他">その他</option>
                </select>
                 <p v-if="state.contentstype === '体験-学生クラス'" class="error">対象：小学校1年生〜中学校3年生</p>
                <p class="error">{{ errors.contentstype }}</p>
              </td>
            </tr>
            
           
            <tr>
              <th>ご希望の日付
                <p class="calendar-text">※お問い合わせ項目を選択すると選択可能日が表示されます。</p>

                 <p class="error2">当日、翌日の体験予約は出来ません。<br>2日後の予約が可能となります。</p>
              </th>
              <td>
                 
                <FullCalendar class="fullcalendarContent fullcalendarMain" ref="fullcalendarMain"
                  :options="calendarOptions" v-click-outside="() => { }" />
                <div class="mt12">{{ state.date }} {{ state.datetime }}</div>
                <!-- <input v-model="state.date" type="date" name="date" />
                <p class="error">{{ errors.date }}</p> -->
              </td>
            </tr>
            <!-- <tr>
              <th>ご希望の時間</th>
              <td>
                <select name="time" v-model="state.datetime">
                  <option value="">時間帯をお選び下さい</option>
                  <option value="10:00~11:00">10:00~11:00</option>
                  <option value="11:00~12:00">11:00~12:00</option>
                  <option value="12:00~13:00">12:00~13:00</option>
                  <option value="13:00~14:00">13:00~14:00</option>
                  <option value="14:00~15:00">14:00~15:00</option>
                  <option value="15:00~16:00">15:00~16:00</option>
                  <option value="16:00~17:00">16:00~17:00</option>
                  <option value="17:00~18:00">17:00~18:00</option>
                  <option value="18:00~19:00">18:00~19:00</option>
                  <option value="19:00~20:00">19:00~20:00</option>
                  <option value="20:00~21:00">20:00~21:00</option>
                  <option value="21:00~22:00">21:00~22:00</option>
                </select>
                <p class="error">{{ errors.datetime }}</p>
              </td>
            </tr> -->
            <tr>
              <th>お問合せ内容</th>
              <td>
                <textarea v-model="state.contents" name="contents" cols="30" rows="3"></textarea>
                <p class="error">{{ errors.contents }}</p>
              </td>
            </tr>
          </tbody>
        </table>
        <button v-if="!valid" :disabled="!valid" type="button">未入力の必須項目があります</button>
        <button v-else-if="valid" type="button" @click="submit">送信</button>
      </form>
      <transition name="fade">
        <div v-if="state.result" class="contact-result">{{ state.result }}</div>
      </transition>

      <div class="contact-bg">
        <img src="~@/assets/img/logo/logo_simple.png" />
      </div>
      <div class="contact-bg2">
        TAKE A<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;BREATH
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, reactive, onMounted, onUpdated, computed,onBeforeUnmount } from 'vue'
import IScroll from 'iscroll'
import dayjs from 'dayjs'
import { useApplicationStore } from '@/store/modules/applicationModule'
import axios from 'axios'
import '@fullcalendar/core/vdom' // solve problem with Vite
import FullCalendar from '@fullcalendar/vue3'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'

interface State {
  iScrollObj: null | IScroll
  slides: any
  current_slide: any
  name: any
  kana: any
  tel: any
  email: any
  result: any
  date: any
  date2: any
  datetime: any
  datetime2: any
  contents: any
  contentstype: any
  selectEvent: any
  selectEventList: any
  allData: any
}

export default defineComponent({
  components: {
     FullCalendar,
  },
  setup() {
    const ApplicationStore = useApplicationStore()
    const root = ref(null)
    const fullcalendarMain = ref(null)
    const state = reactive<State>({
      iScrollObj: null,
      slides: [{ img: require('@/assets/img/contact/1.jpg') }],
      current_slide: null,
      name: '',
      kana: '',
      tel: '',
      email: '',
      result: '',
      date: '',
      date2: '',
      datetime: '',
      datetime2: '',
      contents: '',
      contentstype: '',
      selectEvent: '',
      selectEventList: [],
      allData:'',
    })

    const fetchAllData = function () {
      axios.post('https://cyclone-gym.com/select_all.php', {

      }).then(function (response) {
        //allDataにphpファイルSELECTの結果が配列で格納される
        state.allData = response.data;
      });
    }


    fetchAllData()

    const chackName = computed(() => {
      if (!state.name) {
        return 'お名前を入力してください'
      }
      return ''
    })

    const chackKana = computed(() => {
      if (!state.kana) {
        return 'フリガナを入力してください'
      } else if (!validKatakana(state.kana)) {
        return 'フリガナをカタカナで入力してください'
      }
      return ''
    })

    const validKatakana = function (kana) {
      const re = /^[ァ-ンｧ-ﾝ\x20\u3000ﾞﾟ]*$/
      return re.test(kana)
    }

    const checkTel = computed(() => {
      if (!state.tel) {
        return '電話番号を入力してください'
      } else if (!validTel(state.tel)) {
        return '電話番号を正しく入力してください'
      }
      return ''
    })

    const validTel = function (tel) {
      const re = /^(0[5-9]0[0-9]{8}|0[1-9][1-9][0-9]{7})$/
      return re.test(tel)
    }

    const chackEmail = computed(() => {
      if (!state.email) {
        return 'メールアドレスを入力してください'
      } else if (!validEmail(state.email)) {
        return 'メールアドレスを正しく入力してください'
      }
      return ''
    })

    const validEmail = function (email) {
      const re = /^[a-zA-Z0-9_+-]+(.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/
      return re.test(email)
    }

    const chackDate = computed(() => {
      if (!state.date) {
        return ''
      } else if (validDate(state.date) === false) {
        return '過去の日付は選択できません'
      }
      return ''
    })

    const validDate = function (date) {
      const date2 = dayjs(date).startOf('day')
      const date3 = dayjs(date).day()
      const nowDate = dayjs().startOf('day')
      let result

      if (date2 >= nowDate) {
        result = true
      } else {
        result = false
      }

      return result
    }

    const chackDateTime = computed(() => {
      if (!state.datetime) {
        return ''
      } 

      return ''
    })

    const validDateTime = function (date, datetime) {
      const date2 = dayjs(date).day()

      let result

      if ((date2 === 6 && datetime === '20:00~21:00') || (date2 === 6 && datetime === '21:00~22:00')) {
        result = false
      } else if (
        (date2 === 0 && datetime === '20:00~21:00') ||
        (date2 === 0 && datetime === '21:00~22:00') ||
        (date2 === 0 && datetime === '10:00~11:00') ||
        (date2 === 0 && datetime === '11:00~12:00') ||
        (date2 === 0 && datetime === '18:00~19:00') ||
        (date2 === 0 && datetime === '19:00~20:00')
      ) {
        result = false
      } else {
        result = true
      }

      return result
    }

    const chackContentsType = computed(() => {
      if (!state.contentstype) {
        return 'お問合せ項目を選択してください'
      }
      return ''
    })

    const chackContents = computed(() => {
      return ''
    })

    const errors = computed(() => {
      const errors = {
        name: chackName.value,
        kana: chackKana.value,
        tel: checkTel.value,
        email: chackEmail.value,
        date: chackDate.value,
        datetime: chackDateTime.value,
        contents: chackContents.value,
        contentstype: chackContentsType.value,
      }
      for (var key in errors) {
        if (errors[key] === '' || errors[key] === null || errors[key] === undefined) {
          delete errors[key]
        }
      }
      return errors
    })

    const valid = computed(() => {
      return !Object.keys(errors.value).length
    })

    const submit = async function () {
      ApplicationStore.isLoadComplete2 = true
       
      const result = await send()
      const result2 = await send2()
      ApplicationStore.isLoadComplete2 = false
      state.result = result
      console.log('result');
      
      console.log(state.result);
      
      if (result === 'お問わせありがとうございます。2~3営業日内に返信させて頂きます。') {
        clear()
      }

    }

    const clear = function () {
      state.name = ''
      state.kana = ''
      state.tel = ''
      state.email = ''
      state.contentstype = ''
      state.date = ''
      state.datetime = ''
      state.contents = ''
    }

    const send = async function () {
      const url = 'https://cyclone-gym.com/send.php'
      const params = {
        name: state.name,
        kana: state.kana,
        tel: state.tel,
        email: state.email,
        contentstype: state.contentstype,
        date: state.date,
        datetime: state.datetime,
        contents: state.contents,
      }
      return await axios
        .post(url, params)
        .then(function (res) {
          return res.data
        })
        .catch(function (error) {
          console.log(error)
        })
    }

    const send2 = async function () {
      console.log(state.date);
      const url = 'https://cyclone-gym.com/insert.php'
      axios.post(url, {
        date: state.date,
        datetime: state.datetime,
        contentstype: state.contentstype
      }).then(function (response) {
        console.log(response.data.message);
        if (response.data.message == "success") {
          console.log("登録しました");
          fetchAllData()
        } else {
          console.log(response.data.message);
          
        }
      })
    }

    const shouldShowTopPanel = computed(() => ApplicationStore.getShouldShowTopPanel)

    const myFunc = function () {
      const target = document.getElementsByClassName('price-item-des-numtext')
      const position = Math.floor(window.innerHeight * 0.75)

      for (let i = 0; i < target.length; i++) {
        let offsetTop = Math.floor(target[i].getBoundingClientRect().top)
        let offsetBottom = Math.floor(target[i].getBoundingClientRect().bottom)

        if (offsetTop < position) {
          target[i].classList.add('active')
        } else {
          target[i].classList.remove('active')
        }

        if (offsetBottom < 0) {
          target[i].classList.remove('active')
        }
      }
    }

    const myFunc2 = function () {
      const target = document.getElementsByClassName('arrow-bottom')
      const position = Math.floor(window.innerHeight * 0.75)

      for (let i = 0; i < target.length; i++) {
        let offsetTop = Math.floor(target[i].getBoundingClientRect().top)
        let offsetBottom = Math.floor(target[i].getBoundingClientRect().bottom)

        if (offsetTop < position) {
          target[i].classList.add('active')
        } else {
          target[i].classList.remove('active')
        }

        if (offsetBottom < 0) {
          target[i].classList.remove('active')
        }
      }
    }

    const myFunc5 = function () {
      const target = document.getElementsByClassName('fade-right')
      const target2 = document.getElementById('video')
      const position = Math.floor(window.innerHeight * 0.75)

      for (let i = 0; i < target.length; i++) {
        let offsetTop = Math.floor(target[i].getBoundingClientRect().top)
        let offsetBottom = Math.floor(target[i].getBoundingClientRect().bottom)

        if (offsetTop < position) {
          target[i].classList.add('active')
          target2.classList.remove('active')
        } else {
          target[i].classList.remove('active')
        }

        if (offsetBottom < 0) {
          target[i].classList.remove('active')
        }
      }
    }

    const myFunc6 = function () {
      const target = document.getElementsByClassName('fade-in')
      const position = Math.floor(window.innerHeight * 0.75)

      for (let i = 0; i < target.length; i++) {
        let offsetTop = Math.floor(target[i].getBoundingClientRect().top)
        let offsetBottom = Math.floor(target[i].getBoundingClientRect().bottom)

        if (offsetTop < position) {
          target[i].classList.add('active')
        } else {
          target[i].classList.remove('active')
        }

        if (offsetBottom < 0) {
          target[i].classList.remove('active')
        }
      }
    }

    const myFunc3 = function () {
      const target = document.getElementsByClassName('price-item-des-numtext2-wrap')
      const position = Math.floor(window.innerHeight * 0.75)

      for (let i = 0; i < target.length; i++) {
        let offsetTop = Math.floor(target[i].getBoundingClientRect().top)
        let offsetBottom = Math.floor(target[i].getBoundingClientRect().bottom)

        if (offsetTop < position) {
          target[i].classList.add('active')
        } else {
          target[i].classList.remove('active')
        }

        if (offsetBottom < 0) {
          target[i].classList.remove('active')
        }
      }
    }

    const myFunc4 = function () {
      const target = document.getElementById('title')
      const target2 = document.getElementById('video')
      const position = Math.floor(window.innerHeight * 0.75)

      if (target) {
        let offsetTop = Math.floor(target.getBoundingClientRect().top)
        let offsetBottom = Math.floor(target.getBoundingClientRect().bottom)

        if (offsetTop < position) {
          target.classList.add('active')
          target2.classList.add('active')
        }

        if (offsetBottom < 0) {
          target.classList.remove('active')
          target2.classList.remove('active')
        }
      }
    }
    
    

    onMounted(() => {



      window.addEventListener('scroll', async function () {
        myFunc(), false

        myFunc2(), false

        myFunc3(), false

        myFunc4(), false

        myFunc5(), false

        myFunc6(), false

        
      })

      if (state.current_slide === null) {
        state.current_slide = 0
      }
      setInterval(() => {
        state.current_slide = state.current_slide < state.slides.length - 1 ? state.current_slide + 1 : 0
        console.log(state.current_slide)
      }, 8000)
    })

        const events = computed(() => {
          let result

          switch (state.contentstype) {
            case '見学希望':
              result = [
             {
              title: '○',
              daysOfWeek: [1],
              startTime: '10:00:00',
                },
            {
              title: '○',
              daysOfWeek: [1],
              startTime: '11:00:00',
            }, {
              title: '○',
              daysOfWeek: [1],
              startTime: '12:00:00',
            }, {
              title: '○',
              daysOfWeek: [1],
              startTime: '13:00:00',
            }, {
              title: '○',
              daysOfWeek: [1],
              startTime: '14:00:00',
            }, {
              title: '○',
              daysOfWeek: [1],
              startTime: '15:00:00',
            }, {
              title: '○',
              daysOfWeek: [1],
              startTime: '16:00:00',
            }, {
              title: '○',
              daysOfWeek: [1],
              startTime: '17:00:00',
            }, {
              title: '○',
              daysOfWeek: [1],
              startTime: '18:00:00',
            }, {
              title: '○',
              daysOfWeek: [1],
              startTime: '19:00:00',
            }, {
              title: '○',
              daysOfWeek: [1],
              startTime: '20:00:00',
            },
                 {
              title: '○',
              daysOfWeek: [2],
              startTime: '10:00:00',
            },
            {
              title: '○',
              daysOfWeek: [2],
              startTime: '11:00:00',
            }, {
              title: '○',
              daysOfWeek: [2],
              startTime: '12:00:00',
            }, {
              title: '○',
              daysOfWeek: [2],
              startTime: '13:00:00',
            }, {
              title: '○',
              daysOfWeek: [2],
              startTime: '14:00:00',
            }, {
              title: '○',
              daysOfWeek: [2],
              startTime: '15:00:00',
            }, {
              title: '○',
              daysOfWeek: [2],
              startTime: '16:00:00',
            }, {
              title: '○',
              daysOfWeek: [2],
              startTime: '17:00:00',
            }, {
              title: '○',
              daysOfWeek: [2],
              startTime: '18:00:00',
            }, {
              title: '○',
              daysOfWeek: [2],
              startTime: '19:00:00',
            }, {
              title: '○',
              daysOfWeek: [2],
              startTime: '20:00:00',
            }, {
              title: '○',
              daysOfWeek: [3],
              startTime: '10:00:00',
            },
            {
              title: '○',
              daysOfWeek: [3],
              startTime: '11:00:00',
            }, {
              title: '○',
              daysOfWeek: [3],
              startTime: '12:00:00',
            }, {
              title: '○',
              daysOfWeek: [3],
              startTime: '13:00:00',
            }, {
              title: '○',
              daysOfWeek: [3],
              startTime: '14:00:00',
            }, {
              title: '○',
              daysOfWeek: [3],
              startTime: '15:00:00',
            }, {
              title: '○',
              daysOfWeek: [3],
              startTime: '16:00:00',
            }, {
              title: '○',
              daysOfWeek: [3],
              startTime: '17:00:00',
            }, {
              title: '○',
              daysOfWeek: [3],
              startTime: '18:00:00',
            }, {
              title: '○',
              daysOfWeek: [3],
              startTime: '19:00:00',
            }, {
              title: '○',
              daysOfWeek: [3],
              startTime: '20:00:00',
            }, {
              title: '○',
              daysOfWeek: [4],
              startTime: '10:00:00',
            },
            {
              title: '○',
              daysOfWeek: [4],
              startTime: '11:00:00',
            }, {
              title: '○',
              daysOfWeek: [4],
              startTime: '12:00:00',
            }, {
              title: '○',
              daysOfWeek: [4],
              startTime: '13:00:00',
            }, {
              title: '○',
              daysOfWeek: [4],
              startTime: '14:00:00',
            }, {
              title: '○',
              daysOfWeek: [4],
              startTime: '15:00:00',
            }, {
              title: '○',
              daysOfWeek: [4],
              startTime: '16:00:00',
            }, {
              title: '○',
              daysOfWeek: [4],
              startTime: '17:00:00',
            }, {
              title: '○',
              daysOfWeek: [4],
              startTime: '18:00:00',
            }, {
              title: '○',
              daysOfWeek: [4],
              startTime: '19:00:00',
            }, {
              title: '○',
              daysOfWeek: [4],
              startTime: '20:00:00',
            }, {
              title: '○',
              daysOfWeek: [5],
              startTime: '10:00:00',
            },
            {
              title: '○',
              daysOfWeek: [5],
              startTime: '11:00:00',
            }, {
              title: '○',
              daysOfWeek: [5],
              startTime: '12:00:00',
            }, {
              title: '○',
              daysOfWeek: [5],
              startTime: '13:00:00',
            }, {
              title: '○',
              daysOfWeek: [5],
              startTime: '14:00:00',
            }, {
              title: '○',
              daysOfWeek: [5],
              startTime: '15:00:00',
            }, {
              title: '○',
              daysOfWeek: [5],
              startTime: '16:00:00',
            }, {
              title: '○',
              daysOfWeek: [5],
              startTime: '17:00:00',
            }, {
              title: '○',
              daysOfWeek: [5],
              startTime: '18:00:00',
            }, {
              title: '○',
              daysOfWeek: [5],
              startTime: '19:00:00',
            }, {
              title: '○',
              daysOfWeek: [5],
              startTime: '20:00:00',
            }, 
             {
              title: '○',
              daysOfWeek: [6],
              startTime: '10:00:00',
            },
            {
              title: '○',
              daysOfWeek: [6],
              startTime: '11:00:00',
            }, {
              title: '○',
              daysOfWeek: [6],
              startTime: '12:00:00',
            }, {
              title: '○',
              daysOfWeek: [6],
              startTime: '13:00:00',
            }, {
              title: '○',
              daysOfWeek: [6],
              startTime: '14:00:00',
            }, {
              title: '○',
              daysOfWeek: [6],
              startTime: '15:00:00',
            }, {
              title: '○',
              daysOfWeek: [6],
              startTime: '16:00:00',
            }, {
              title: '○',
              daysOfWeek: [6],
              startTime: '17:00:00',
            }, {
              title: '○',
              daysOfWeek: [6],
              startTime: '18:00:00',
            }, {
              title: '○',
              daysOfWeek: [6],
              startTime: '19:00:00',
            },{
              title: '○',
              daysOfWeek: [0],
              startTime: '12:00:00',
            }, {
              title: '○',
              daysOfWeek: [0],
              startTime: '13:00:00',
            }, {
              title: '○',
              daysOfWeek: [0],
              startTime: '14:00:00',
            }, {
              title: '○',
              daysOfWeek: [0],
              startTime: '15:00:00',
            }, {
              title: '○',
              daysOfWeek: [0],
              startTime: '16:00:00',
            }
          ]
              break;

           case 'その他':
          result = [
            {
              title: '○',
              daysOfWeek: [1],
              startTime: '10:00:00',
            },
            {
              title: '○',
              daysOfWeek: [1],
              startTime: '11:00:00',
            }, {
              title: '○',
              daysOfWeek: [1],
              startTime: '12:00:00',
            }, {
              title: '○',
              daysOfWeek: [1],
              startTime: '13:00:00',
            }, {
              title: '○',
              daysOfWeek: [1],
              startTime: '14:00:00',
            }, {
              title: '○',
              daysOfWeek: [1],
              startTime: '15:00:00',
            }, {
              title: '○',
              daysOfWeek: [1],
              startTime: '16:00:00',
            }, {
              title: '○',
              daysOfWeek: [1],
              startTime: '17:00:00',
            }, {
              title: '○',
              daysOfWeek: [1],
              startTime: '18:00:00',
            }, {
              title: '○',
              daysOfWeek: [1],
              startTime: '19:00:00',
            }, {
              title: '○',
              daysOfWeek: [1],
              startTime: '20:00:00',
            }, 
            {
              title: '○',
              daysOfWeek: [2],
              startTime: '10:00:00',
            },
            {
              title: '○',
              daysOfWeek: [2],
              startTime: '11:00:00',
            }, {
              title: '○',
              daysOfWeek: [2],
              startTime: '12:00:00',
            }, {
              title: '○',
              daysOfWeek: [2],
              startTime: '13:00:00',
            }, {
              title: '○',
              daysOfWeek: [2],
              startTime: '14:00:00',
            }, {
              title: '○',
              daysOfWeek: [2],
              startTime: '15:00:00',
            }, {
              title: '○',
              daysOfWeek: [2],
              startTime: '16:00:00',
            }, {
              title: '○',
              daysOfWeek: [2],
              startTime: '17:00:00',
            }, {
              title: '○',
              daysOfWeek: [2],
              startTime: '18:00:00',
            }, {
              title: '○',
              daysOfWeek: [2],
              startTime: '19:00:00',
            }, {
              title: '○',
              daysOfWeek: [2],
              startTime: '20:00:00',
            },  {
              title: '○',
              daysOfWeek: [3],
              startTime: '10:00:00',
            },
            {
              title: '○',
              daysOfWeek: [3],
              startTime: '11:00:00',
            }, {
              title: '○',
              daysOfWeek: [3],
              startTime: '12:00:00',
            }, {
              title: '○',
              daysOfWeek: [3],
              startTime: '13:00:00',
            }, {
              title: '○',
              daysOfWeek: [3],
              startTime: '14:00:00',
            }, {
              title: '○',
              daysOfWeek: [3],
              startTime: '15:00:00',
            }, {
              title: '○',
              daysOfWeek: [3],
              startTime: '16:00:00',
            }, {
              title: '○',
              daysOfWeek: [3],
              startTime: '17:00:00',
            }, {
              title: '○',
              daysOfWeek: [3],
              startTime: '18:00:00',
            }, {
              title: '○',
              daysOfWeek: [3],
              startTime: '19:00:00',
            }, {
              title: '○',
              daysOfWeek: [3],
              startTime: '20:00:00',
            }, {
              title: '○',
              daysOfWeek: [4],
              startTime: '10:00:00',
            },
            {
              title: '○',
              daysOfWeek: [4],
              startTime: '11:00:00',
            }, {
              title: '○',
              daysOfWeek: [4],
              startTime: '12:00:00',
            }, {
              title: '○',
              daysOfWeek: [4],
              startTime: '13:00:00',
            }, {
              title: '○',
              daysOfWeek: [4],
              startTime: '14:00:00',
            }, {
              title: '○',
              daysOfWeek: [4],
              startTime: '15:00:00',
            }, {
              title: '○',
              daysOfWeek: [4],
              startTime: '16:00:00',
            }, {
              title: '○',
              daysOfWeek: [4],
              startTime: '17:00:00',
            }, {
              title: '○',
              daysOfWeek: [4],
              startTime: '18:00:00',
            }, {
              title: '○',
              daysOfWeek: [4],
              startTime: '19:00:00',
            }, {
              title: '○',
              daysOfWeek: [4],
              startTime: '20:00:00',
            }, {
              title: '○',
              daysOfWeek: [5],
              startTime: '10:00:00',
            },
            {
              title: '○',
              daysOfWeek: [5],
              startTime: '11:00:00',
            }, {
              title: '○',
              daysOfWeek: [5],
              startTime: '12:00:00',
            }, {
              title: '○',
              daysOfWeek: [5],
              startTime: '13:00:00',
            }, {
              title: '○',
              daysOfWeek: [5],
              startTime: '14:00:00',
            }, {
              title: '○',
              daysOfWeek: [5],
              startTime: '15:00:00',
            }, {
              title: '○',
              daysOfWeek: [5],
              startTime: '16:00:00',
            }, {
              title: '○',
              daysOfWeek: [5],
              startTime: '17:00:00',
            }, {
              title: '○',
              daysOfWeek: [5],
              startTime: '18:00:00',
            }, {
              title: '○',
              daysOfWeek: [5],
              startTime: '19:00:00',
            }, {
              title: '○',
              daysOfWeek: [5],
              startTime: '20:00:00',
            },
            {
              title: '○',
              daysOfWeek: [6],
              startTime: '10:00:00',
            },
            {
              title: '○',
              daysOfWeek: [6],
              startTime: '11:00:00',
            }, {
              title: '○',
              daysOfWeek: [6],
              startTime: '12:00:00',
            }, {
              title: '○',
              daysOfWeek: [6],
              startTime: '13:00:00',
            }, {
              title: '○',
              daysOfWeek: [6],
              startTime: '14:00:00',
            }, {
              title: '○',
              daysOfWeek: [6],
              startTime: '15:00:00',
            }, {
              title: '○',
              daysOfWeek: [6],
              startTime: '16:00:00',
            }, {
              title: '○',
              daysOfWeek: [6],
              startTime: '17:00:00',
            }, {
              title: '○',
              daysOfWeek: [6],
              startTime: '18:00:00',
            }, {
              title: '○',
              daysOfWeek: [6],
              startTime: '19:00:00',
            }, {
              title: '○',
              daysOfWeek: [0],
              startTime: '12:00:00',
            }, {
              title: '○',
              daysOfWeek: [0],
              startTime: '13:00:00',
            }, {
              title: '○',
              daysOfWeek: [0],
              startTime: '14:00:00',
            }, {
              title: '○',
              daysOfWeek: [0],
              startTime: '15:00:00',
            }, {
              title: '○',
              daysOfWeek: [0],
              startTime: '16:00:00',
            }
          ]
              break;
          
          case '体験-フリータイム枠':
          result = [
            // {
            //   title: '○',
            //   daysOfWeek: [1],
            //   startTime: '11:30:00',
            //   endTime: '12:00:00',
            // },
            //   {
            //   title: '○',
            //   daysOfWeek: [1],
            //   startTime: '12:00:00',
            // },
             {
              title: '○',
              daysOfWeek: [1],
              startTime: '13:00:00',
            },
             {
              title: '○',
              daysOfWeek: [1],
              startTime: '14:00:00',
            },
             {
              title: '○',
              daysOfWeek: [1],
              startTime: '15:00:00',
            }, {
              title: '○',
              daysOfWeek: [1],
              startTime: '16:00:00',
            }, {
              title: '○',
              daysOfWeek: [1],
              startTime: '19:00:00',
            }, 
            {
              title: '○',
              daysOfWeek: [2],
              startTime: '12:00:00',
            },
             {
              title: '○',
              daysOfWeek: [2],
              startTime: '13:00:00',
            },
            {
              title: '○',
              daysOfWeek: [2],
              startTime: '14:00:00',
            },
            {
              title: '○',
              daysOfWeek: [2],
              startTime: '15:00:00',
            }, {
              title: '○',
              daysOfWeek: [2],
              startTime: '16:00:00',
            }, {
              title: '○',
              daysOfWeek: [2],
              startTime: '19:00:00',
              endTime: '19:30:00',
            },
            {
              title: '○',
              daysOfWeek: [3],
              startTime: '12:00:00',
            },
            {
              title: '○',
              daysOfWeek: [3],
              startTime: '13:00:00',
            },
            {
              title: '○',
              daysOfWeek: [3],
              startTime: '14:00:00',
            },
            {
              title: '○',
              daysOfWeek: [3],
              startTime: '15:00:00',
            }, {
              title: '○',
              daysOfWeek: [3],
              startTime: '16:00:00',
            }, {
              title: '○',
              daysOfWeek: [3],
              startTime: '19:00:00',
            }, 
            {
              title: '○',
              daysOfWeek: [4],
              startTime: '12:00:00',
            },
            {
              title: '○',
              daysOfWeek: [4],
              startTime: '13:00:00',
            },
            {
              title: '○',
              daysOfWeek: [4],
              startTime: '14:00:00',
            },
            {
              title: '○',
              daysOfWeek: [4],
              startTime: '15:00:00',
            }, {
              title: '○',
              daysOfWeek: [4],
              startTime: '16:00:00',
            }, {
              title: '○',
              daysOfWeek: [4],
              startTime: '19:00:00',
            }, 
     
            {
              title: '○',
              daysOfWeek: [5],
              startTime: '13:00:00',
            },
            {
              title: '○',
              daysOfWeek: [5],
              startTime: '14:00:00',
            },
            {
              title: '○',
              daysOfWeek: [5],
              startTime: '15:00:00',
            }, {
              title: '○',
              daysOfWeek: [5],
              startTime: '16:00:00',
            }, {
              title: '○',
              daysOfWeek: [5],
              startTime: '19:00:00',
              endTime: '19:30:00',
            }, 
            {
              title: '○',
              daysOfWeek: [6],
              startTime: '10:00:00',
            },
            {
              title: '○',
              daysOfWeek: [6],
              startTime: '11:00:00',
            }, {
              title: '○',
              daysOfWeek: [6],
              startTime: '15:30:00',
              endTime: '16:00:00',
            },  {
              title: '○',
              daysOfWeek: [6],
              startTime: '16:00:00',
              endTime: '17:00:00',
            }, {
              title: '○',
              daysOfWeek: [6],
              startTime: '19:00:00',
            },
             {
              title: '○',
              daysOfWeek: [0],
              startTime: '12:00:00',
            }, {
              title: '○',
              daysOfWeek: [0],
              startTime: '13:00:00',
            }, {
              title: '○',
              daysOfWeek: [0],
              startTime: '14:00:00',
            }, {
              title: '○',
              daysOfWeek: [0],
              startTime: '15:00:00',
            }, {
              title: '○',
              daysOfWeek: [0],
              startTime: '16:00:00',
            }
          ]
              break;
          case '体験-キック初級クラス':
          result = [
            {
              title: '○',
              daysOfWeek: [1],
              startTime: '10:00:00',
            }, {
              title: '○',
              daysOfWeek: [2],
              startTime: '10:00:00',
            }, {
              title: '○',
              daysOfWeek: [2],
              startTime: '20:00:00',
            }, {
              title: '○',
              daysOfWeek: [4],
              startTime: '10:00:00',
            }, {
              title: '○',
              daysOfWeek: [4],
              startTime: '20:00:00',
            }, {
              title: '○',
              daysOfWeek: [6],
              startTime: '13:00:00',
              endTime: '14:00:00',
            }
          ]
              break;
            case '体験-エントリーキッククラス':
              result = [
              {
                  title: '○',
                  daysOfWeek: [2],
                  startTime: '19:30:00',
                  endTime: '20:00:00',
                }
              ]
              break;
            case '体験-レディースエントリークラス':
              result = [
              {
                  title: '○',
                  daysOfWeek: [5],
                  startTime: '10:00:00',
                  endTime: '10:30:00',
                }
              ]
              break;

            case '体験-レディースキッククラス':
              result = [
                {
                  title: '○',
                  daysOfWeek: [3],
                  startTime: '10:00:00',
                  endTime: '11:00:00',
                },
                {
                  title: '○',
                  daysOfWeek: [5],
                  startTime: '10:30:00',
                  endTime: '11:30:00',
                }
              ]
              break;

               case '体験-学生クラス':
              result = [
                 {
                  title: '○',
                  daysOfWeek: [1],
                  startTime: '17:00:00',
                  endTime: '18:00:00',
                },
                {
                  title: '○',
                  daysOfWeek: [1],
                  startTime: '18:00:00',
                  endTime: '18:30:00',
                },
                  {
                  title: '○',
                  daysOfWeek: [2],
                  startTime: '17:00:00',
                  endTime: '18:00:00',
                },
                {
                  title: '○',
                  daysOfWeek: [2],
                  startTime: '18:00:00',
                  endTime: '18:30:00',
                },
                  {
                  title: '○',
                  daysOfWeek: [3],
                  startTime: '17:00:00',
                  endTime: '18:00:00',
                },
                 {
                  title: '○',
                  daysOfWeek: [3],
                  startTime: '18:00:00',
                  endTime: '18:30:00',
                },
                 {
                  title: '○',
                  daysOfWeek: [4],
                  startTime: '17:00:00',
                  endTime: '18:00:00',
                },
                 {
                  title: '○',
                  daysOfWeek: [4],
                  startTime: '18:00:00',
                  endTime: '18:30:00',
                },
               {
                  title: '○',
                  daysOfWeek: [5],
                  startTime: '17:00:00',
                  endTime: '18:00:00',
                },
                 {
                  title: '○',
                  daysOfWeek: [5],
                  startTime: '18:00:00',
                  endTime: '18:30:00',
                },{
                  title: '○',
                  daysOfWeek: [6],
                  startTime: '17:00:00',
                  endTime: '18:00:00',
                },
                 {
                  title: '○',
                  daysOfWeek: [6],
                  startTime: '18:00:00',
                  endTime: '18:30:00',
                },
               
              ]
              break;
          
          // case '体験-ヨガクラス':
          //     result = [
          //       {
          //         title: '○',
          //         daysOfWeek: [1],
          //         startTime: '11:00:00',
          //       },
          //   {
          //     title: '○',
          //     daysOfWeek: [4],
          //     startTime: '20:00:00',
          //   },
          //    {
          //     title: '○',
          //     daysOfWeek: [6],
          //     startTime: '13:00:00',
          //   },
          // ]
          //     break;
          //   case '体験-ピラティスクラス':
          //     result = [
          //       {
          //         title: '○',
          //         daysOfWeek: [1],
          //         startTime: '11:00:00',
          //       },
          //       {
          //         title: '○',
          //         daysOfWeek: [4],
          //         startTime: '20:00:00',
          //       },
          //       {
          //         title: '○',
          //         daysOfWeek: [6],
          //         startTime: '13:00:00',
          //       },
          //     ]
          //     break;
            default:
          result = []
          break;
      }
      return result
        })

    const getDayAndCount = (date) => {
      return { day: date.getDay(), count: Math.floor((date.getDate() - 1) / 7) + 1 };
    }
    

     const calendarOptions = computed(() => {
      return reactive({
        locale: 'ja',
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        height: '100%',
        contentHeight: 'auto',
        titleFormat: { year: 'numeric', month: 'long' }, // デザインと異なるが確認のため西暦も表示
        slotLabelFormat: {
          hour: 'numeric',
          minute: '2-digit',
          omitZeroMinute: false,
          meridiem: false,
         
        },
        initialView: 'timeGridWeek',
        views: {
          timeGridWeek: {
            slotDuration: '01:00:00', // 1時間ごとにスロットを表示
            slotMinTime: '10:00:00',
            slotMaxTime: '22:00:00',
            dayHeaderFormat: function (date) {
                          const day = date.date.day;
              const weekNum = date.date.marker.getDay();
              const week = ['(日)', '(月)', '(火)', '(水)', '(木)', '(金)', '(土)'][weekNum];

              return `${day}\n${week}`;
            },
             header: {
              // title, prev, next, prevYear, nextYear, today
              left: 'prev,next today',
              center: 'title',
            },
          },
        },
        allDaySlot: false, // 終日表示
        duration: { days: 7 },
        initialDate: dayjs(new Date()).format('YYYY-MM-DD'),
        weekends: true,
        firstDay: 1,
        showNonCurrentDates: false,
        dayMaxEvents: true,
        displayEventTime: false,
       
        buttonText: {
          prev: '前の一週間へ', // <
          next: '次の一週間へ', // >
          today: '今週へ',
          month: '月',
          week: '週',
          day: '日'
        },
        events: events.value,
        eventDidMount: async (e) => {
          const date = dayjs()
          const pastDate = dayjs(e.event.start)
         const twoDaysBefore = pastDate.subtract(3, 'day');
          

          if (date.isAfter(twoDaysBefore, 'day')) {
    e.el.classList.add('dateActiveNo');
  }

          if (date > pastDate) {
            e.el.classList.add('dateActiveNo');
          }
          

          if (state.date2) {
            const date2 = dayjs(e.event.start).format('YYYY-MM-DD')
            const datetime2 = dayjs(e.event.start).format('HH:mm')

            if (date2 === state.date && datetime2 === state.datetime) {
             e.el.classList.add('dateActive');
            }
          }

          const date2 = dayjs(e.event.start).format('YYYY-MM-DD')
          const datetime2 = dayjs(e.event.start).format('HH:mm')

          if (state.contentstype == "体験-ヨガクラス") {
            const a = getDayAndCount(e.event.start)
            console.log(a);
            if (a.count === 1 || a.count === 3 || a.count === 5) {
              e.el.classList.add('dateActiveNone');
            }
          } else if (state.contentstype == "体験-ピラティスクラス") {
            const a = getDayAndCount(e.event.start)
            console.log(a);
            if (a.count === 2 || a.count === 4 ) {
              e.el.classList.add('dateActiveNone');
            }
          }


                  
          
          if (state.allData) {
            const checkDate = state.allData.some(data => data.date === date2 && data.datetime === datetime2 && data.contentstype === state.contentstype)


            if (checkDate) {
              e.el.classList.add('dateActiveNo');
              // e.event.title = "×"
              console.log(e.event.title);
              e.event.setProp('title', "×")
            } else {
              e.event.setProp('title', "○")
            }
          }

         
          


        },
        eventClick: function (info) {


          console.log(info);

          state.selectEvent = info.event

          console.log(info.event.url);
          
          

          console.log(info.event.title);
          
          
          state.date = dayjs(info.event.start).format('YYYY-MM-DD')
          state.datetime = dayjs(info.event.start).format('HH:mm')
          

           const t = fullcalendarMain.value.calendar.el.querySelector(`.dateActive`)

          if (t) {
             t.classList.remove('dateActive');
          }

           info.el.classList.add('dateActive');
          
          // change the border color just for fun
        
        },
      })
     })

     


  

    return {
      root,
      state,
      submit,
      send,
      errors,
      valid,
      calendarOptions,
      fullcalendarMain,
    }
  },
})
</script>

<style lang="scss" scoped>
@import '~@/assets/css/colors';

.call2 {
  width: 100vw;
  min-height: 100vh;
  height: 100%;
  padding-bottom: 240px;
  color: rgb(88, 87, 76);
}

img {
  width: 100%;
}

div,
p,
h2,
ul,
li {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}


:deep(.dateActiveNo) {
  
  opacity: .3;
 pointer-events: none;



}

:deep(.dateActiveNone) {

  opacity: 0;
  pointer-events: none;



}

:deep(.fc .fc-col-header-cell-cushion) {
     padding: 2px 5px;
}

:deep(.fc .fc-timegrid-slot) {
   height: 3em;
}

:deep(.fc-v-event .fc-event-title) {
      display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

:deep(.fc-timegrid-event-harness > .fc-timegrid-event) {
  cursor: pointer;
}

:deep(.fc .fc-toolbar) {
  flex-direction: column;
}

:deep(.fc .fc-button-primary) {
  font-size: 1.2rem;
    width: 110px;
    border: 1px solid #c2c3cc;
    border-radius: 25px;
    padding: 5px;
    display: flex;
    justify-content: center;
    letter-spacing: 1.5px;
    background-color: #fff;
    color: #58574c;
}

:deep(.fc-direction-ltr .fc-button-group > .fc-button:not(:last-child)) {
  border-top-right-radius:25px;
  border-bottom-right-radius: 25px;
}

:deep(.fc-direction-ltr .fc-button-group > .fc-button:not(:first-child)){
    border-top-left-radius:25px;
    border-bottom-left-radius:25px;
}

:deep(.fc .fc-button-primary:not(:disabled):active, .fc .fc-button-primary:not(:disabled).fc-button-active){
      background-color: #ff4081;
    border: 1px solid #ff025a;
    color: #fff;
}

:deep(.fc .fc-toolbar .fc-toolbar-chunk){
  width: 100%;
}

:deep(.fc .fc-today-button){
  margin-left: auto;
  display: none;
}

:deep(.fc .fc-button-group){
  margin-left: 0;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}

:deep(.fc .fc-button-group > .fc-button) {
  flex: inherit;
}

:deep(.fc .fc-toolbar-title) {
  font-size: 1.5em;
  text-align: center;
}

:deep(.fc .fc-col-header-cell-cushion){
  color: #58574c;
}

:deep(.fc-v-event){
  background-color: #ada554;
  border: 1px solid #ad9654;
  font-size: 1.65rem;
}

:deep(.dateActive) {
   background-color: #ff4081;
  border: 1px solid #ff025a;
}

:deep(.fc-event-selected:after, .fc-event:focus:after){
  background: inherit;
}


.calendar-text {
  font-weight: 600;
}

.contact {
  width: 100%;
  max-width: 600px;
  padding: 28px;
  margin: 0 auto;
  font-family: 'Shippori Mincho', serif;
  position: relative;

  &-bg {
    opacity: 0.1;
    position: fixed;
    right: 0;
    bottom: 0;
    z-index: -1;
  }

  &-bg2 {
    font-family: 'mafw';
    font-size: 6rem;
    opacity: 0.1;
    position: fixed;
    left: 40px;
    top: 100px;
    z-index: -1;
  }

  & .top-items-title {
    text-align: center;

    h2 {
      font-size: 1.4rem;
      font-family: 'Shippori Mincho', serif;
    }
    p {
      font-size: 3.2rem;
      font-weight: 400;
      margin-bottom: 40px;
      font-family: 'Shippori Mincho', serif;
    }
  }
}

.contact-form table {
  width: 100%;
  margin: 0 0 28px 0;
  border-collapse: collapse;
}
.contact-form table tr {
  border-bottom: 1px solid #c2c3cc;
  display: flex;
  align-items: flex-start;
}
.contact-form table tbody tr th {
  width: 25%;
  padding: 20px 10px;
  text-align: left;
}
.contact-form table tbody tr td {
  width: 75%;
  padding: 20px;
  text-align: left;
}
.contact-form table tbody tr td input {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  font-family: 'Shippori Mincho', serif;
}
.contact-form .error {
  margin: 0;
  margin-top: 5px;
  color: #f40800;
  font-weight: bold;
  font-size: 1.2rem;
}
.contact-form button {
  display: block;
  width: 300px;
  padding: 10px 0;
  margin: 0 auto;
  color: #ffffff;
  border: 0;
  box-shadow: none;
  background-color: $sub;
  cursor: pointer;
}
.contact-form button:disabled {
  background-color: #a5a5a5;
}
.contact-result {
  padding: 5px 0;
  margin: 28px auto 0 auto;
  color: #ffffff;
  box-sizing: border-box;
  background-color: $sub;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.7s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.slider-outer {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  margin: 0 auto 20px;
}

.top-inner {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  color: #fff;
  font-size: 8rem;
  font-family: 'Shippori Mincho', serif;
  font-weight: 500;
  letter-spacing: 0.5px;
  text-align: center;

  & .top-items-title {
    text-align: center;

    h2 {
      font-size: 2rem;
    }
    p {
      font-size: 4.8rem;
    }
  }
}

.slider-inner {
  position: relative;
  width: 100%;
  height: 100%;
}

.slide-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 800ms ease 0s;
  opacity: 1;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active {
  transition: transform 8000ms ease-out 0s;
  transform: scale(1.2);
}

.fade-enter-to {
  transform: scale(1.1);
}

.over-ray {
  width: 100%;
  height: 100%;
  background-color: rgba($color: #000000, $alpha: 0.5);
  position: absolute;
  top: 0;
}

.title-wrap {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  text-align: center;
  flex-direction: column;
  margin-bottom: 120px;
  font-weight: 900;

  & h1 {
    font-size: 4rem;
    font-weight: 900;
    line-height: 1;
  }

  & h2 {
    font-size: 3rem;
    font-weight: 900;
  }
}

#title {
  text-align: center;
}

.top-inner {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;

  &-img {
    max-width: 600px;
    width: 100%;
  }
}

.l_noiseMotion,
.l_videoBox .l_video {
  // height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.l_videoBox .l_video {
  object-fit: cover;
  position: relative;
}

.TopPageVideo {
  left: 28.6%;
  position: fixed;
  top: 5vw;
  width: 67%;
  z-index: 1;
  -webkit-transition: all 1s;
  -moz-transition: all 1s;
  -ms-transition: all 1s;
  -o-transition: all 1s;
  transition: all 1s;

  &.active {
    position: fixed;
    width: 100%;
    left: 0;
    top: 0;
    -webkit-transition: all 1s;
    -moz-transition: all 1s;
    -ms-transition: all 1s;
    -o-transition: all 1s;
    transition: all 1s;

    &.l_videoBox .l_videoBoxInner {
      height: 0;
      overflow: hidden;
      padding-bottom: 100%;
      position: relative;
      width: 100%;
    }

    &.l_videoBox .l_video {
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: auto;
    }
  }
}

.l_videoBox {
  overflow: hidden;
}

.l_videoBox .l_videoBoxInner {
  height: 0;
  overflow: hidden;
  padding-bottom: 53%;
  position: relative;
  width: 100%;
}

.l_noiseMotion {
  animation: noise 0.2s steps(1) infinite;
  backface-visibility: hidden;
  background: #010719 url('~@/assets/img/video/noise_bg.png') repeat 0 0;
  background-repeat: repeat;
  background-size: 200px 200px;
  bottom: 0;
  opacity: 0.5;
  overflow: hidden;
  pointer-events: none;
  right: 0;
  transform-origin: 50% 50%;
  will-change: transform;
  z-index: 2;
}

.TopPage .l_primaryContent {
  position: relative;
  z-index: 3;
}

.TopPageHead {
  position: relative;
  padding-bottom: 140px;
  // pointer-events: none;
  z-index: 2;
  padding-top: 100px;
}

.l_primaryBox {
  padding-left: 4.4%;
  padding-right: 4.4%;
}

.TopPageHead .TopPageHeadTitle {
  position: relative;
  width: 60%;
  z-index: 2;
}

.TopPageHead .TopPageHeadTitle .TopPageHeadTitleRead {
  bottom: 0;
  color: #fff;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0.02em;
  position: absolute;
  right: -12vw;
}

.head-title {
  color: #fff;
  font-size: 8rem;
  font-family: 'Montserrat', sans-serif;
}

.head-subtitle-wrap {
  margin-top: 120px;
  width: 100%;
  position: relative;

  & .price-item-des-wrap-one .price-item-des {
    margin-top: 0;
  }

  & .price-item-des-wrap {
    color: #fff;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;

    & .price-item-des-title {
      font-size: 30px;
    }

    & .arrow-bottom {
      display: inline-block;
      width: 18px;
      height: 18px;
      margin: 0 40px;
      border-bottom: 4px solid #fff;
      border-right: 4px solid #fff;
      transform: translateX(-100%) rotate(-45deg);
      opacity: 0;
      -webkit-transition: all 1s;
      -moz-transition: all 1s;
      -ms-transition: all 1s;
      -o-transition: all 1s;
      transition: all 1s;

      &.active {
        transform: translateX(0) rotate(-45deg);
        opacity: 1;
      }
    }
  }
}

.head-subtitle-bottomwrap {
  display: flex;
  flex-direction: column;
  align-items: center;

  .head-subtitle {
    text-align: center;
    color: #fff;
    font-size: 6rem;
  }
}

.head-subtitle {
  color: #fff;
  background-color: $sub;
  display: inline-block;
  padding: 5px;
  font-size: 4rem;
  font-weight: 900;
}

.js-inViewAct {
  animation: inViewActKey 1s;
  animation-delay: 0s;
  animation-fill-mode: forwards;
  animation-timing-function: cubic-bezier(0.4, 0.005, 0.14, 1);
  backface-visibility: hidden;
  transform-origin: left top;
  will-change: transform;
}

.WhiteBack {
  background-color: #fff;
  position: relative;
  z-index: 3;
}

.BlackBack {
  // background-color: $main;
  color: #fff;
  position: relative;
  z-index: 3;
}

.price-item {
  display: flex;
  font-size: 20px;
  font-weight: 900;
  margin-bottom: 40px;
  flex-direction: column;
  width: 33%;

  &-wrap {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
  }

  &-middle {
    &-wrap {
      display: flex;
      align-items: center;
      flex-direction: column;
    }
  }
}

.price-item-title {
  width: 100%;
  height: 70px;
  margin: 15px 0;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-right: 70px;
  background: $main;
  position: relative;
  color: #fff;
}

.price-item-des {
  &-numtext {
    font-size: 50px;
    margin-right: -3px;
    position: relative;

    &::after {
      position: absolute;
      bottom: calc(50% - 5px);
      left: 0;
      content: '';
      width: 100%;
      height: 5px;
      background: $sub;
      transform: scale(0, 1);
      transform-origin: left top;
      transition: transform 0.5s;
    }

    &.active::after {
      transform: scale(1, 1);
    }
  }
}

.price-item-des {
  &-numtext2 {
    font-size: 50px;
    margin-right: -3px;
    position: relative;
    color: $sub;

    &-wrap {
      position: relative;

      opacity: 0;
      -webkit-transition: all 1s;
      -moz-transition: all 1s;
      -ms-transition: all 1s;
      -o-transition: all 1s;
      transition: all 1s;

      &.active {
        opacity: 1;
      }
    }

    &-tag {
      position: absolute;
      width: 100px;
      background: $sub;
      color: #fff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      top: 0;
      left: -105px;
      font-size: 1.2rem;
      transform: rotate(-5deg);
      color: #fff;
    }
  }

  &-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 100%;

    &-one {
      .price-item-des {
        margin-top: 70px;
      }
    }
  }
}

.arrow-bottom {
  display: inline-block;
  width: 18px;
  height: 18px;
  margin: auto 10px 20px;
  border-bottom: 4px solid #000;
  border-right: 4px solid #000;
  transform: translateY(-100%) rotate(45deg);
  opacity: 0;
  -webkit-transition: all 1s;
  -moz-transition: all 1s;
  -ms-transition: all 1s;
  -o-transition: all 1s;
  transition: all 1s;

  &.active {
    transform: translateY(0) rotate(45deg);
    opacity: 1;
  }
}

.contact-button {
  width: 300px;
  height: 100px;
  border-radius: 15px;
  background: #ffffff;
  box-shadow: 5px -5px 47px #b0b0b0, -5px 5px 47px #ffffff;

  // &-wrap {
  //   border-radius: 21px;
  //     background: #ffffff;
  //     box-shadow: inset 5px 5px 10px #666666,
  //       inset -5px -5px 10px #ffffff;
  // }
}

.TopPageService {
}

.fade-right {
  transform: translateX(-100%);
  opacity: 0;
  -webkit-transition: all 1s;
  -moz-transition: all 1s;
  -ms-transition: all 1s;
  -o-transition: all 1s;
  transition: all 1s;

  &.active {
    transform: translateX(0);
    opacity: 1;
  }
}

.fade-in {
  opacity: 0;
  -webkit-transition: all 1s;
  -moz-transition: all 1s;
  -ms-transition: all 1s;
  -o-transition: all 1s;
  transition: all 1s;

  &.active {
    opacity: 1;
  }
}

.recommend {
  &- {
    &wrap {
      margin-top: 160px;
      padding-left: 23%;
      padding-top: 160px;
      font-weight: 900;
      color: #fff;
    }

    &title {
      font-family: 'Montserrat', sans-serif;
      font-size: 2rem !important;
      color: #f2f2f2;
    }

    &text {
      font-size: 8rem;
      word-break: keep-all;
    }
  }
}

.member-wrap {
  display: flex;

  & li {
    max-width: 320px;

    img {
      transition: 1s all;
    }

    &:hover {
      img {
        transform: scale(1.2, 1.2);
        transition: 1s all;
      }

      & .icon-arrow-left {
        background-color: $sub;
      }
    }

    & .pic {
      height: 100%;
      overflow: hidden;
    }

    & .tmName {
      position: relative;
      display: block;
      font-size: 1.2rem;
      line-height: 2em;
      letter-spacing: 0.04em;
      background-color: #fff;
      text-align: center;
      color: #333;
      width: 85%;
      z-index: 99999;
      padding: 5% 0;
      margin: -20px auto 0;
    }

    & .icon-arrow-left {
      position: absolute;
      right: 15px;
      top: -15px;
      width: 30px;
      height: 30px;
      background-color: #000;
      -webkit-transition: all 1s;
      -moz-transition: all 1s;
      -ms-transition: all 1s;
      -o-transition: all 1s;
      transition: all 1s;

      &:after {
        content: '';
        display: inline-block;
        width: 15px;
        height: 15px;
        margin-left: -7.5px;
        margin-top: 7.5px;
        border-bottom: 2px solid #fff;
        border-right: 2px solid #fff;
        transform: rotate(-45deg);
      }
    }

    & .name {
      position: relative;
      display: block;
      font-size: 1.4rem;
      font-weight: 700;
    }

    & .home {
      position: relative;
      display: block;
    }

    & .kinds {
      display: block;
      margin-top: 5px;
      width: 100%;
    }
  }
}

.button {
  position: relative;
  font-family: 'Montserrat', sans-serif;
  display: flex;
  font-size: 3rem;
  font-weight: bold;
  line-height: 2em;
  letter-spacing: 0.04em;
  background-color: #fff;
  text-align: center;
  color: $main;
  max-width: 300px;
  width: 100%;
  z-index: 99999;
  height: 100%;
  justify-content: center;
  align-items: center;

  &:hover {
    & .icon-arrow-left {
      background-color: $sub !important;
    }
  }

  &-wrap {
    height: 100px;
    margin: 40px 0 80px;

    &.black {
      .button {
        background-color: $main;
        color: #fff;
      }

      .icon-arrow-left {
        background-color: #fff;

        &:after {
          content: '';
          display: inline-block;
          width: 15px;
          height: 15px;
          margin-left: -7.5px;
          margin-top: 7.5px;
          border-bottom: 2px solid $main;
          border-right: 2px solid $main;
          transform: rotate(-45deg);
        }
      }
    }
  }

  & .icon-arrow-left {
    position: absolute;
    right: 15px;
    top: -15px;
    width: 30px;
    height: 30px;
    background-color: #000;
    display: flex;
    /* align-items: center; */
    justify-content: center;
    -webkit-transition: all 1s;
    -moz-transition: all 1s;
    -ms-transition: all 1s;
    -o-transition: all 1s;
    transition: all 1s;

    &:after {
      content: '';
      display: inline-block;
      width: 15px;
      height: 15px;
      margin-left: -7.5px;
      margin-top: 7.5px;
      border-bottom: 2px solid #fff;
      border-right: 2px solid #fff;
      transform: rotate(-45deg);
    }
  }
}

.access-wrap {
  &-item {
    &.title {
      font-size: 2.4rem;
      font-weight: bold;
      letter-spacing: 0.05em;
      font-family: 'Montserrat', sans-serif;
    }

    &.des {
      font-size: 1.4rem;
      margin-bottom: 56px;
      letter-spacing: 0.05em;
    }
  }
}

.container {
  position: relative;
  margin: 70px auto;
  width: 90%;
  perspective: 1000px;
}

.container .title {
  position: absolute;
  top: -3.5rem;
  width: 100%;
  z-index: 10;
  font-size: 2.5rem;
  text-align: center;
}

.container .title p {
  position: relative;
  display: inline-block;
  width: min-content;
  font-size: 2rem;
}

.box {
  position: absolute;
  top: 90%;
  left: 15%;
  display: inline-block;
  width: 70%;
  height: 3px;
  border-radius: 50%;
  background-color: #000;
  filter: blur(5px);
}

/* 立方体 */
.cube {
  position: relative;
  margin: 30px auto;
  width: 500px;
  height: 500px;
  transform-style: preserve-3d;
  /* 子要素を3D空間 */
  animation: rotate 20s linear infinite;
}

@keyframes rotate {
  from {
    transform: rotateX(-10deg) rotateY(20deg);
  }

  to {
    transform: rotateX(-10deg) rotateY(-340deg);
  }
}

.cube:hover {
  animation-play-state: paused;
  /* 回転一時停止 */
}

.cube li {
  position: absolute;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
}

.top {
  transform: translate3d(0, -250px, 0) rotateX(90deg);
  background-color: #fff;
  opacity: 0.7;
}

.front {
  transform: translate3d(0, 0, -250px);
}

.right {
  transform: translate3d(-250px, 0, 0) rotateY(90deg);
}

.back {
  transform: translate3d(0px, 0px, 250px) rotateY(180deg);
}

.left {
  transform: translate3d(250px, 0, 0) rotateY(-90deg);
}

.image-box {
  position: relative;
  display: flex;
  justify-content: center;
  overflow: hidden;
}

// img {
//   width: auto;
//   height: 500px;
//   transition: all 1s ease;
// }

.image-box:hover img {
  transform: translateY(-200px);
}

.image-box:hover p {
  z-index: 1;
}

.access-cont {
  display: flex;
  justify-content: space-between;
}

.waku {
  display: block;

  & img {
    max-width: 50px;
    height: auto;
    width: 100%;
    -webkit-filter: grayscale(1);
    filter: $main;
    filter: grayscale(1);
  }

  & img:hover {
    -webkit-filter: grayscale(0);
    filter: none;
    filter: grayscale(0);
  }
}

.tag {
  background-color: $sub;
  display: inline-block;
  margin-top: 5px;
  padding: 5px 10px;
  color: #fff;
}

.error2 {
  margin: 0;
  margin-top: 10px;
  color: #f40800;
  font-weight: bold;
  font-size: 1.2rem;
}
@media screen and (max-width: 500px) {
  .contact-form table tr {
    flex-direction: column;
  }

  .contact-form table tbody tr th {
    padding: 20px 10px 0;
    width: 100%;
  }

  .contact-form table tbody tr td {
    width: 100%;
  }
}

@media screen and (max-width: 768px) {
  .contact-bg {
    width: 40%;

    &2 {
      font-size: 3rem;
    }
  }
}
</style>
